import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { selectSiteUrl } from 'core/selectors/app';
import { addExternalAttributesIfNeeded } from 'core/utils/helpers/externalLink';

function MarketingLink({
  url,
  siteUrl,
  children,
  dispatch, // exclude from auto-passed props
  tagHelper,
  ...props
}) {
  const handleRef = useCallback((ref) => {
    tagHelper && tagHelper(ref); // handle Chase tagging implementation
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <a href={url} ref={handleRef} {...addExternalAttributesIfNeeded(url, siteUrl)} {...props}>{children}</a>;
}

const mapStateToProps = state => ({
  siteUrl: selectSiteUrl(state),
});

export default connect(mapStateToProps)(MarketingLink);
